import React from 'react';
import { TrendingUp } from 'lucide-react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from 'recharts';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { usd } from '@/lib/billingApi';

const tick = (v) => `$${v >= 1000 ? `${(v / 1000).toFixed(1)}k` : v}`;

export const RevenueChart = ({ months }) => {
  const hasTest = !!months?.some((m) => m.test > 0);
  const empty = !months || !months.some((m) => m.card || m.paypal || m.test);
  return (
    <Card className="border-slate-200">
      <CardHeader className="pb-2">
        <CardTitle className="text-lg flex items-center gap-2">
          <TrendingUp className="w-5 h-5 text-[#00247D]" />Monthly revenue (last 12 months)
        </CardTitle>
      </CardHeader>
      <CardContent>
        {empty ? (
          <div className="h-56 flex items-center justify-center text-sm text-slate-400" data-testid="revenue-chart-empty">
            {months ? 'No revenue data yet' : 'Loading…'}
          </div>
        ) : (
          <div className="h-64" data-testid="monthly-revenue-chart">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={months} margin={{ top: 10, right: 12, left: 0, bottom: 0 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" vertical={false} />
                <XAxis dataKey="label" stroke="#64748b" fontSize={11} />
                <YAxis stroke="#64748b" fontSize={11} tickFormatter={tick} />
                <Tooltip formatter={(v, name) => [usd(v), name]} labelStyle={{ fontWeight: 700, color: '#0f172a' }}
                  contentStyle={{ borderRadius: 8, border: '1px solid #e2e8f0' }} />
                <Legend wrapperStyle={{ fontSize: 12 }} />
                <Bar dataKey="card" name="Card (Plug'n Pay)" stackId="r" fill="#00247D" />
                <Bar dataKey="paypal" name="PayPal" stackId="r" fill="#F59E0B" />
                {hasTest && <Bar dataKey="test" name="Test (simulated)" stackId="r" fill="#94a3b8" />}
              </BarChart>
            </ResponsiveContainer>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
